module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar logo = (helpers.detectRenderedImage(model.logo, model._logo) || {}).rendered || {};\n%>\n<div class=\"<%- model.type.data %> <%- model.color.data %>\">\n<div class=\"background\">&nbsp;</div>\n<div class=\"content\">\n<% if(model.type.data == \"contact\" || model.type.data == \"contact-form\"){ %>\n<%- helpers.renderSection(); %>\n<% } else { %>\n<img class=\"navLogo\" title=\"<%= logo.title %>\" alt=\"<%= logo.alt %>\" src=\"<%= logo.url %>\">\n<%- model.panelTopHtml || '' %>\n<%- model.panelBottomHtml || '' %>\n<% } %>\n</div>\n</div>"
  , __filename = "components/templates/headPanel/sidePanel.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var logo = (helpers.detectRenderedImage(model.logo, model._logo) || {}).rendered || {};

    ; __line = 3
    ; __append("\n<div class=\"")
    ; __line = 4
    ; __append( model.type.data )
    ; __append(" ")
    ; __append( model.color.data )
    ; __append("\">\n<div class=\"background\">&nbsp;</div>\n<div class=\"content\">\n")
    ; __line = 7
    ;  if(model.type.data == "contact" || model.type.data == "contact-form"){ 
    ; __append("\n")
    ; __line = 8
    ; __append( helpers.renderSection() )
    ; __append("\n")
    ; __line = 9
    ;  } else { 
    ; __append("\n<img class=\"navLogo\" title=\"")
    ; __line = 10
    ; __append(escapeFn( logo.title ))
    ; __append("\" alt=\"")
    ; __append(escapeFn( logo.alt ))
    ; __append("\" src=\"")
    ; __append(escapeFn( logo.url ))
    ; __append("\">\n")
    ; __line = 11
    ; __append( model.panelTopHtml || '' )
    ; __append("\n")
    ; __line = 12
    ; __append( model.panelBottomHtml || '' )
    ; __append("\n")
    ; __line = 13
    ;  } 
    ; __append("\n</div>\n</div>")
    ; __line = 15
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/headPanel/sidePanel.ejs

}